/**
 * Lecture des nombres saisis à la main.
 *
 * Point non négociable sur iPhone : le pavé décimal d'un iPhone configuré en
 * français produit une **virgule**, pas un point. Sans la conversion ci-dessous,
 * saisir « 0,25 lot » donnerait un champ invalide, et l'utilisateur verrait le
 * calcul disparaître sans comprendre pourquoi.
 */

/**
 * Normalise une saisie en nombre décimal exploitable par le backend.
 *
 * Retourne `null` si la saisie n'est pas encore un nombre exploitable — cas
 * courant pendant la frappe (« 0. », « », « -"). L'appelant s'abstient alors
 * de lancer un calcul plutôt que d'afficher une erreur à chaque caractère.
 */
export function parseDecimalInput(raw: string, { allowZero = false } = {}): string | null {
  const cleaned = raw.trim().replace(',', '.')
  if (cleaned === '') return null
  if (!/^\d*\.?\d*$/.test(cleaned)) return null

  const value = Number(cleaned)
  if (!Number.isFinite(value)) return null
  if (!allowZero && value <= 0) return null
  if (allowZero && value < 0) return null

  return cleaned
}

/** Affiche une chaîne décimale du backend, ou un tiret si absente. */
export function display(value: string | null | undefined, suffix = ''): string {
  if (value === null || value === undefined || value === '') return '—'
  return suffix ? `${value} ${suffix}` : value
}
